import React, { useContext, useEffect, useRef, useState } from "react";
import { CanvasContext } from "../../../contexts/CanvasContext";

export default function AudioComponent({ audio }) {
  const { hoveredDivision, files } = useContext(CanvasContext);
  const [audioUrl, setAudioUrl] = useState(null);
  const isHovered = audio.id === hoveredDivision;
  const [isDivHovered, setIsDivHovered] = useState(false);
  const [isDivFocused, setIsDivFocused] = useState(false);
  const [isDivActive, setIsDivActive] = useState(false);

  const audioRef = useRef(null);

  useEffect(() => {
    const fetchAudio = async () => {
      if (audio.url && audio.url.startsWith("./")) {
        const audioName = audio.url.replace("./", "");
        const file = files.find((f) => f.name === audioName);
        if (file && file.data) {
          setAudioUrl(file.data);
        } else {
          console.error("Audio not found in files:", audioName);
        }
      } else {
        setAudioUrl(audio.url);
      }
    };

    fetchAudio();
  }, [audio.url, files]);

  const focusedStyles =
    isDivFocused && audio.pseudoClass === "focus"
      ? {
          width: audio.focusedwidth || audio.width || "300px",
          height: audio.focusedheight || audio.height || "54px",

          padding: audio.focusedpadding || audio.padding || "0",
          paddingTop: audio.focusedpaddingTop || audio.focusedpadding || "0",
          paddingRight:
            audio.focusedpaddingRight || audio.focusedpadding || "0",
          paddingBottom:
            audio.focusedpaddingBottom || audio.focusedpadding || "0",
          paddingLeft: audio.focusedpaddingLeft || audio.focusedpadding || "0",
          margin: audio.focusedmargin || audio.margin || "0px",
          marginTop: audio.focusedmarginTop || audio.focusedmargin || "0px",
          marginRight: audio.focusedmarginRight || audio.focusedmargin || "0px",
          marginBottom:
            audio.focusedmarginBottom || audio.focusedmargin || "0px",
          marginLeft: audio.focusedmarginLeft || audio.focusedmargin || "0px",

          borderTop:
            audio.focusedborderTop ||
            audio.focusedborder ||
            audio.border ||
            "none",
          borderRight:
            audio.focusedborderRight ||
            audio.focusedborder ||
            audio.border ||
            "none",
          borderBottom:
            audio.focusedborderBottom ||
            audio.focusedborder ||
            audio.border ||
            "none",
          borderLeft:
            audio.focusedborderLeft ||
            audio.focusedborder ||
            audio.border ||
            "none",
          borderSapcing:
            audio.focusedborderSpacing || audio.borderSpacing || "0px",
          borderCollapse:
            audio.focusedborderCollapse || audio.borderCollapse || "0px",
          borderRadius: audio.focusedborderRadius || audio.borderRadius || "0",
          outline: audio.focusedoutline || audio.outline || "none",

          position: audio.focusedposition || audio.position || "relative",
          top: audio.focusedtop || audio.top || "auto",
          right: audio.focusedright || audio.right || "auto",
          bottom: audio.focusedbottom || audio.bottom || "auto",
          left: audio.focusedleft || audio.left || "auto",
          zIndex: audio.focusedzIndex || audio.zIndex || "auto",

          boxShadow: audio.focusedboxShadow || audio.boxShadow || "none",
          opacity: audio.focusedOpacity || audio.opacity || 1,
          cursor: audio.focusedcursor || audio.cursor || "default",
          visibility: audio.focusedvisibility || "visible",

          transform: audio.focusedtransform || audio.transform || "none",
          transition: audio.focusedtransition || audio.transition || "none",
        }
      : {};

  const hoverStyles =
    isDivHovered && audio.pseudoClass === "hover"
      ? {
          width: audio.hoveredwidth || audio.width || "300px",
          height: audio.hoveredheight || audio.height || "54px",

          padding: audio.hoveredpadding || audio.padding || "0",
          paddingTop: audio.hoveredpaddingTop || audio.hoveredpadding || "0",
          paddingRight:
            audio.hoveredpaddingRight || audio.hoveredpadding || "0",
          paddingBottom:
            audio.hoveredpaddingBottom || audio.hoveredpadding || "0",
          paddingLeft: audio.hoveredpaddingLeft || audio.hoveredpadding || "0",
          margin: audio.hoveredmargin || audio.margin || "0px",
          marginTop: audio.hoveredmarginTop || audio.hoveredmargin || "0px",
          marginRight: audio.hoveredmarginRight || audio.hoveredmargin || "0px",
          marginBottom:
            audio.hoveredmarginBottom || audio.hoveredmargin || "0px",
          marginLeft: audio.hoveredmarginLeft || audio.hoveredmargin || "0px",

          borderTop:
            audio.hoveredborderTop ||
            audio.hoveredborder ||
            audio.border ||
            "none",
          borderRight:
            audio.hoveredborderRight ||
            audio.hoveredborder ||
            audio.border ||
            "none",
          borderBottom:
            audio.hoveredborderBottom ||
            audio.hoveredborder ||
            audio.border ||
            "none",
          borderLeft:
            audio.hoveredborderLeft ||
            audio.hoveredborder ||
            audio.border ||
            "none",
          borderSapcing:
            audio.hoveredborderSpacing || audio.borderSpacing || "0px",
          borderCollapse:
            audio.hoveredborderCollapse || audio.borderCollapse || "0px",
          borderRadius: audio.hoveredborderRadius || audio.borderRadius || "0",
          outline: audio.hoveredoutline || audio.outline || "none",

          position: audio.hoveredposition || audio.position || "relative",
          top: audio.hoveredtop || audio.top || "auto",
          right: audio.hoveredright || audio.right || "auto",
          bottom: audio.hoveredbottom || audio.bottom || "auto",
          left: audio.hoveredleft || audio.left || "auto",
          zIndex: audio.hoveredzIndex || audio.zIndex || "auto",

          boxShadow: audio.hoveredboxShadow || audio.boxShadow || "none",
          opacity: audio.hoveredOpacity || audio.opacity || 1,
          cursor: audio.hoveredcursor || audio.cursor || "default",
          visibility: audio.hoveredvisibility || "visible",

          transform: audio.hoveredtransform || audio.transform || "none",
          transition: audio.hoveredtransition || audio.transition || "none",
        }
      : {};

  const activeStyles =
    isDivActive && audio.pseudoClass === "active"
      ? {
          width: audio.activatedwidth || audio.width || "300px",
          height: audio.activatedheight || audio.height || "54px",

          padding: audio.activatedpadding || audio.padding || "0",
          paddingTop:
            audio.activatedpaddingTop || audio.activatedpadding || "0",
          paddingRight:
            audio.activatedpaddingRight || audio.activatedpadding || "0",
          paddingBottom:
            audio.activatedpaddingBottom || audio.activatedpadding || "0",
          paddingLeft:
            audio.activatedpaddingLeft || audio.activatedpadding || "0",
          margin: audio.activatedmargin || audio.margin || "0px",
          marginTop: audio.activatedmarginTop || audio.activatedmargin || "0px",
          marginRight:
            audio.activatedmarginRight || audio.activatedmargin || "0px",
          marginBottom:
            audio.activatedmarginBottom || audio.activatedmargin || "0px",
          marginLeft:
            audio.activatedmarginLeft || audio.activatedmargin || "0px",

          borderTop:
            audio.activatedborderTop ||
            audio.activatedborder ||
            audio.border ||
            "none",
          borderRight:
            audio.activatedborderRight ||
            audio.activatedborder ||
            audio.border ||
            "none",
          borderBottom:
            audio.activatedborderBottom ||
            audio.activatedborder ||
            audio.border ||
            "none",
          borderLeft:
            audio.activatedborderLeft ||
            audio.activatedborder ||
            audio.border ||
            "none",
          borderSapcing:
            audio.activatedborderSpacing || audio.borderSpacing || "0px",
          borderCollapse:
            audio.activatedborderCollapse || audio.borderCollapse || "0px",
          borderRadius:
            audio.activatedborderRadius || audio.borderRadius || "0",
          outline: audio.activatedoutline || audio.outline || "none",

          position: audio.activatedposition || audio.position || "relative",
          top: audio.activatedtop || audio.top || "auto",
          right: audio.activatedright || audio.right || "auto",
          bottom: audio.activatedbottom || audio.bottom || "auto",
          left: audio.activatedleft || audio.left || "auto",
          zIndex: audio.activatedzIndex || audio.zIndex || "auto",

          boxShadow: audio.activatedboxShadow || audio.boxShadow || "none",
          opacity: audio.activatedOpacity || audio.opacity || 1,
          cursor: audio.activatedcursor || audio.cursor || "default",
          visibility: audio.activatedvisibility || "visible",

          transform: audio.activatedtransform || audio.transform || "none",
          transition: audio.activatedtransition || audio.transition || "none",
        }
      : {};

  const AudioStyle = {
    width: audio.width || "300px",
    height: audio.height || "54px",

    paddingRight: audio.paddingRight || audio.padding || "0px",
    paddingBottom: audio.paddingBottom || audio.padding || "0px",
    paddingLeft: audio.paddingLeft || audio.padding || "0px",
    marginTop: audio.marginTop || audio.margin || "0px",
    marginRight: audio.marginRight || audio.margin || "0px",
    marginBottom: audio.marginBottom || audio.margin || "0px",
    marginLeft: audio.marginLeft || audio.margin || "0px",

    borderTop: isHovered
      ? "1px dashed #555"
      : audio.borderTop || audio.border || "none",
    borderRight: isHovered
      ? "1px dashed #555"
      : audio.borderRight || audio.border || "none",
    borderBottom: isHovered
      ? "1px dashed #555"
      : audio.borderBottom || audio.border || "none",
    borderLeft: isHovered
      ? "1px dashed #555"
      : audio.borderLeft || audio.border || "none",
    borderSapcing: audio.borderSpacing || "0px",
    borderCollapse: audio.borderCollapse || "0px",
    borderRadius: audio.borderRadius || "0",
    outline: audio.outline || "none",

    position: audio.position || "static",
    top: audio.top || "auto",
    right: audio.right || "auto",
    bottom: audio.bottom || "auto",
    left: audio.left || "auto",
    zIndex: audio.zIndex || "auto",

    boxShadow: audio.boxShadow || "none",
    opacity: audio.opacity || "1",
    boxSizing: audio.boxSizing || "border-box",
    display: audio.display || "block",
    visibility: audio.visibility || "visible",
    cursor: audio.cursor || "auto",

    objectFit: audio.objectFit || "contain",
    objectPosition: audio.objectPosition || "50% 50%",
    transform: audio.transform || "none",
    transition: audio.transition || "none",
    clipPath: audio.clipPath || "none",
    float: audio.float || "none",
    clear: audio.clear || "none",

    scale: isHovered ? "1.01" : "1",
    ...hoverStyles,
    ...focusedStyles,
    ...activeStyles,
  };

  useEffect(() => {
    if (audioRef.current) {
      // Set playbackRate using the DOM API
      audioRef.current.playbackRate =
        audio.playbackRate !== undefined ? audio.playbackRate : 1;
    }
  }, [audio.playbackRate]);

  return (
    <audio
      ref={audioRef}
      style={AudioStyle}
      src={audioUrl || ""}
      autoPlay={audio.autoplay || false}
      controls={audio.controls !== false}
      loop={audio.loop || false}
      muted={audio.muted || false}
      preload={audio.preload || "auto"}
      volume={audio.volume !== undefined ? audio.volume : 1}
      onMouseEnter={() => setIsDivHovered(true)}
      onMouseLeave={() => setIsDivHovered(false)}
      onFocus={() => setIsDivFocused(true)}
      onBlur={() => setIsDivFocused(false)}
      onMouseDown={() => setIsDivActive(true)}
      onMouseUp={() => setIsDivActive(false)}
    >
      Your browser does not support the audio element.
    </audio>
  );
}
